import React, { useRef, useState } from 'react';
import { TimeoutAnimation } from '../loader/timeout-animation';

import '../../styles/App.css';
import './popup.css';
import infoSvg from '../../assets/img/info-circle-mid.svg';

export function Popup({type, setValidationState, message, showTimer, heading}){

    //#region States
    const [showPopup, setPopup] = useState(true);
    const [ showLoader, setShowLoader ] = useState(false);
    let tooltipRef1 = useRef(null);
    let tooltipRef2 = useRef(null);
    //#endregion

    //#region constants
    const tooltips = {
        textOne:`Vodafone GmbH, Ferdinand-Braun-Platz 1, 40549 Düsseldorf, Vodafone
                Kabel Deutschland GmbH (voraussichtlich ab 01.02.2021 firmierend
                unter Vodafone Deutschland GmbH), Betastraße 6-8, 85774
                Unterföhring sowie Vodafone West GmbH, Vodafone Hessen GmbH & Co.
                KG, Vodafone BW GmbH, Vodafone NRW GmbH, alle Aachener Str.
                746-750, 50933 Köln.`,
        textTwo:`Aus den Bereichen Mobilfunk, Internet & Festnetz, TV, Multimedia und
              Entertainment, Internet of Things (IoT) und Cloud-/Hosting Dienste
              sowie dazugehörige Hardware und Software.`
    }
    const data = {
        successHeader:'Erfolg!!!',
        success: 'Vielen Dank, Ihre E-Mail Adresse wurde erfolgreich aktualisiert und bestätigt!',
        failureHeader:'Operation fehlgeschlagen!!! Versuchen Sie es nochmal',
        failure: 'Das hat leider nicht geklappt',
        errorHeader:'Operation fehlgeschlagen!!! Versuchen Sie es nach einer Weile erneut',
        error: 'Das hat leider nicht geklappt',
        heading1:'Dein Porfil ist noch nicht volständig.\nMach es jetzt komplett,',
        heading2:'Dein Profil ist noch nicht vollständig.\nMach es jetzt komplett und gib uns Deine Einwilligung.',
        versionA: <React.Fragment>
                    Ja, ich willige ein, dass die
                    <span><a href="https://www.google.co.in"> Vodafone-Unternehmen </a></span>
                    <span className='tool-tip' data-tip={tooltips.textOne} ref={tooltipRef1}>
                        <img className='img' src={infoSvg} alt="info-svg"></img>
                    </span>, 
                    auch wechselseitig füreinander, mich telefonisch und per elektronischer Post
                    (z.B. E-Mail, Messenger, SMS und MMS) bezüglich 
                    <span className='tool-tip' data-tip={tooltips.textTwo} ref={tooltipRef2}>
                        <img className='img' src={infoSvg} alt="info-svg"></img>
                    </span>
                    <a href="www.facebook.com"> Produkten und 
                    Dienstleistungen </a> zu Werbezwecken und zur Marktforschung kontaktieren.
                </React.Fragment>,
        versionB: null, //version B is just vesion A but with heading 2
        versionC: <React.Fragment>
                    Schon gewusst? Nur wenn Du ausdrücklich zustimmst, 
                    dürfen wir Dich z.B. über persönliche Angebote und 
                    Treue-Aktionen informieren. Jetzt prüfen und in Zukunft 
                    nichts mehr verpassen.
                </React.Fragment>, //version C is just version A with added version C at the beginning
        common: <React.Fragment>
                    <b>Ich kann meine Einwilligung jederzeit ganz 
                    oder teilweise für die Zukunft widerrufen.</b>
                </React.Fragment>,
        callEndpoint: ()=>{
            setPopup(false)
            setValidationState({complete:false, type:null});
            return
        }
    }
    //#endregion

    //#region fragment
    function popupFragment(type){
        if(type===undefined || type.toLowerCase() === 'opt'){
            return(
                <>
                <h2 className='heading red'>{data.heading1}</h2>
                <div className='contents'>{data.versionA}</div>
                <div className='contents'>{data.common}</div>
                <div>
                    <button className='btn' onClick={()=>{data.callEndpoint()}}>Weiter ohne Einwilligung</button>
                    <button className='btn violet' onClick={()=>{data.callEndpoint()}}>Ja, ich willige ein</button>
                </div>
                </>
            )
        }
        else if ( type.toLowerCase() === 'success') {
            return(
                <div>
                    <h2 className='heading green'>{heading}</h2>
                    <p className='text'>{message||data.success}</p>
                </div>
            )
        }
        else if ( type.toLowerCase() === 'fail') {
            return(
                <div>
                    <h2 className='heading red'>{heading}</h2>
                    <p className='text'>{message || data.failure}</p>
                </div>
            )
        }
        else if (type.toLowerCase() === 'error') {
            return(
                <div>
                    <h2 className='heading red'>{heading}</h2>
                    <p className='text'>{message}</p>
                </div>
            )
        }
    }
    //#endregion

    //#region hide popup
    function hidePopup(){
        setPopup(false);
        if(showTimer){
            setShowLoader(true);
        } else{
            setValidationState({complete:false, type:null});
        }
    }
    //#endregion

    function hideLoader(){
        setShowLoader(false);
        setValidationState({complete:false, type:null});
    }

    return(
        <div>
            {showPopup ?
                <div className='dialog' style={{animationName:'slide-up'}}>
                    {popupFragment(type)}
                    {type.toLowerCase() !== 'opt' ? 
                        <div className='popup-button-container'>
                            <button 
                            className='btn' 
                            onClick={hidePopup}>OK</button>
                            </div>
                    :null}
                </div> 
            :null}
            {showLoader?<TimeoutAnimation hideLoader={hideLoader}/>:null}
        </div>
    )
}
